import { InventoryColumns } from "../../../Data/Driver/CarInventoryListing";
import React, { Fragment, useContext, useState } from "react";
import ActionOptions from "../../Common/Component/ActionOptions";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import AssignBooking from "../../Driver/AssignBooking";
import LocateDriver from "../../Driver/LocateDriver";
import NotifyDriver from "../../Driver/NotifyDriver";
import QuickActions from "./QuickActions";
import BlockDriver from "../../Driver/BlockDriver";
import ResetDriver from "../../Driver/ResetDriver";
import moment from "moment";
import { Spinner } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
const InventoryListTable = ({
  inventoryData,
  paginationPerPage,
  paginationTotalRows,
  onChangePage,
  onChangeRowsPerPage,
  setShowApiLoader,
  globalCityField,
  fetchCarData,
  setPageNumber,
  pagination,
  pageNumber,
  loader,
  filterData,
  searchData
}) => {
  const [assignBookingModal, setAssignBookingModal] = useState(false);
  const toggleAssignBookingModal = () =>
    setAssignBookingModal(!assignBookingModal);

  const [locateDriverModal, setLocateDriverModal] = useState(false);
  const toggleLocateDriverModal = () =>
    setLocateDriverModal(!locateDriverModal);

  const [notifyDriverModal, setNotifyDriverModal] = useState(false);
  const toggleNotifyDriverModal = () =>
    setNotifyDriverModal(!notifyDriverModal);

  const [blockDriverModal, setBlockDriverModal] = useState(false);
  const toggleBlockDriverModal = () => setBlockDriverModal(!blockDriverModal);

  const [resetDriverModal, setResetDriverModal] = useState(false);
  const toggleResetDriverModal = () => setResetDriverModal(!resetDriverModal);
  const [driverObj, setDriverObj] = useState({});
  const {mix_background_layout} = useContext(CustomizerContext)
  const processData = inventoryData.map((element, index) => {
    return {
      driverName: element.driverName ? element.driverName : "-",
      carNo: element.carNo ? element.carNo : "-",
      currentCarStatus: element.currentCarStatus
        ? element.currentCarStatus
        : "-",
      lat: element.lat ? element.lat : "-",
      lng: element.lng ? element.lng : "-",
      driverMobile: element.driverMobile ? element.driverMobile : "-",
      lastDutyOn: element.lastDutyOn
        ? moment(new Date(element.lastDutyOn)).format("MMM DD HH:mm")
        : "-",
      lastUpdatedOn: element.lastUpdatedOn
        ? moment(new Date(element.lastUpdatedOn)).format("MMM DD HH:mm")
        : "-",
    };
  });
  return (
    <Fragment>
      <div className="table-responsive ">
        {/* <CommonDataTable options={{
                    columns:driverColumns,
                    data:processData,
                    center:true
                }}
                /> */}
        <DataTable
          columns={InventoryColumns}
          data={processData}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          paginationDefaultPage={pageNumber}
          paginationPerPage={paginationPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          paginationServer
          progressPending={loader}
          progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
            <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
          </div>}
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
    </Fragment>
  );
};
export default InventoryListTable;
